module.exports = __webpack_public_path__ + "img/recommed-img1.04aaab15.jpg";